// TutorBird Integration Configuration
// ============================================
// Widget-Scripts aus TutorBird Dashboard
// (Settings → Website → Widget-Code kopieren)
// ============================================

export const TUTORBIRD = {
  // TutorBird Subdomain (für direkten Portal-Link)
  subdomain: 'avantitutor',
  get portalUrl() { return `https://${this.subdomain}.tutorbird.com`; },

  // Script-Widgets aus TutorBird (Source-URLs aus den <script>-Tags)
  widgets: {
    // Anmelde-Widget (Login)
    login: 'https://app.tutorbird.com/Widget/v4/Widget.ashx?settings=eyJTY2hvb2xJRCI6InNjaF80M3dKVCIsIldlYnNpdGVJRCI6Indic181U3FKNSIsIldlYnNpdGVCbG9ja0lEIjoid2JiX1c2OGJKNSJ9',
    // Buchungs-Widget (Termin buchen)
    booking: 'https://app.tutorbird.com/Widget/v4/Widget.ashx?settings=eyJTY2hvb2xJRCI6InNjaF80M3dKVCIsIldlYnNpdGVJRCI6Indic181U3FKNSIsIldlYnNpdGVCbG9ja0lEIjoid2JiXzdINUpKSCJ9',
    // Hier später Signup-Widget URL einfügen, sobald verfügbar
    signup: '',
  },

  configured: true,
};
